export const setNameRowStay = (index?: number) => `schedulesAddStay.${index}`
